import { queryClient } from 'stateManagement/queries/client';

export const handleGetContractAnalysisData = async ({ action }) => {
  const {
    params: { chain, address },
  } = action;
  try {
    const walletProfileData = queryClient.getQueryData([
      'contract-analysis',
      chain,
      address,
    ]);

    let toReturn = {
      rawData: walletProfileData,
    };

    return toReturn;
  } catch (error) {
    console.error('Failed to extract wallet profile data', error);
    return null;
  }
};
